import * as React from 'react';
import { memo } from 'react';

const SvgNav = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m.91 10 17.272-8.182L10 19.091l-1.818-7.273L.909 10Z", stroke: "#fff" })));
const Memo = memo(SvgNav);

export { Memo as default };
